import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';

export default function useAnalyticsScope(orgId) {
  const [scope, setScope] = useState({ businessFunctions: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!orgId) {
      setScope({ businessFunctions: [] });
      setError(null);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    const res = await analyticsService.getScope(orgId);
    if (res.ok) {
      setScope({
        orgId: res.data?.org_id,
        businessFunctions: res.data?.business_functions || [],
      });
    } else {
      setScope({ businessFunctions: [] });
      setError(typeof res.data === 'string' ? res.data : 'Failed to load scope');
    }
    setIsLoading(false);
  }, [orgId]);

  useEffect(() => {
    load();
  }, [load]);

  return { scope, isLoading, error, reload: load };
}
